module.exports = __webpack_public_path__ + "static/media/total-related-parties-blue.46f4b3d9.svg";